<template>
    <v-menu v-model="menu" :close-on-content-click="false" offset-x eager>
        <template v-slot:activator="{ on }">
            <div class="text-left">
                <v-btn block tile class="text-left" color="#f7d9cd" v-on="on" style="box-shadow: none;">
                        <span class="primary--text">
                            <slot name="titulo"></slot>
                        </span>
                    <v-spacer></v-spacer>
                </v-btn>
            </div>
        </template>

        <v-card class="primary--text" :min-width="minWidth">
            <v-card-title class="pt-2 pb-1 pl-2 pr-1 font-weight-bold title">
                {{dialogoTitulo}}
                <v-spacer></v-spacer>
                <v-btn icon right @click="cerrarMenu" color="white" style="background: #40108e; border-radius: 0px">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-row no-gutters>
                <v-col cols="12" class="pa-2">
                    <div class="caption">{{descripcion}}</div>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="6" class="pl-4 pr-4">
                    <slot name="opcion1"></slot>
                </v-col>
                <v-col cols="6" class="pl-4 pr-4">
                    <slot name="opcion2"></slot>
                </v-col>
            </v-row>
        </v-card>
    </v-menu>
</template>

<script>
    export default {
        name: "DialogoOpciones",
        props: {
            dialogoTitulo: {type: String, required: true},
            descripcion: {type: String, required: true},
            minWidth: {type: String, default: undefined}
        },
        data: function () {
            return {
                menu: false
            }
        },
        methods: {
            cerrarMenu() {
                this.menu = false;
            },
        }
    }
</script>

<style lang="scss">
    .v-menu__content {
        box-shadow: none !important;
        border-radius: 0px;
        margin-left: 0px;

        .v-card {
            border: 2px solid #40108e;
            border-radius: 0px;
        }

        fieldset {
            border: 2px solid #40108e !important;
            border-radius: 0 !important;

            .v-input__append-inner {
                margin-top: 22px !important;
                line-height: 22px !important;
            }
        }

        .v-card__title {
            font-size: 16px !important;
            font-weight: bold !important;
            border-bottom: 2px solid #40108e;
            padding: 0 0 0 10px !important;
        }
    }

    .v-application.sm-up {
        .v-menu__content {
            .v-card {
                margin-left: 20px;
            }

            .v-card__title::before {
                content: '';
                width: 0;
                height: 0;
                position: absolute;
                margin-left: -30px;
                border-top: 22px solid transparent;
                border-bottom: 22px solid transparent;
                border-right: 20px solid #40108e;
            }
        }
    }
</style>